import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class ExternalReleaseDate extends Field {
  static attributesForModel(modelClass) {
    return ['externalReleaseDate'];
  }

  get title() {
    return `External ${terminology('release')} date`;
  }

  exampleContents(): FieldContentsData {
    return { text: dateFormattedWithUserLocale(moment().add(4, 'months')) };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.externalReleaseDate) {
      return {
        text: dateFormattedWithUserLocale(record.externalReleaseDate),
      };
    }

    return {};
  }
}
